import React, { useState, useEffect, useId } from 'react';
import { GoogleOAuthProvider, useGoogleLogin } from '@react-oauth/google';
import api from '../services/api';
// Se você usar React Router Dom, descomente a linha abaixo:
// import { useNavigate } from 'react-router-dom';

// ==================================================================================
// ÍCONES SVG SUPREMOS (Material 3 / strokeWidth 1.5)
// ==================================================================================
const Icons = {
  Logo: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 2L2 7l10 5 10-5-10-5z"></path>
      <path d="M2 17l10 5 10-5"></path>
      <path d="M2 12l10 5 10-5"></path>
    </svg>
  ),
  Google: () => (
    <svg width="18" height="18" viewBox="0 0 48 48" fill="none">
      <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"/>
      <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"/>
      <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"/>
      <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"/>
    </svg>
  ),
  Glasses: () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><circle cx="6" cy="15" r="4"></circle><circle cx="18" cy="15" r="4"></circle><path d="M14 15a2 2 0 0 0-4 0"></path><path d="M2.5 13 5 7c.7-1.3 1.4-2 3-2"></path><path d="M21.5 13 19 7c-.7-1.3-1.5-2-3-2"></path></svg>,
  WhatsApp: () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"></path></svg>,
  MapPin: () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path><circle cx="12" cy="10" r="3"></circle></svg>,
  User: () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg>,
  Lock: () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect><path d="M7 11V7a5 5 0 0 1 10 0v4"></path></svg>,
  Eye: () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7Z"></path><circle cx="12" cy="12" r="3"></circle></svg>,
  EyeOff: () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M9.88 9.88a3 3 0 1 0 4.24 4.24"></path><path d="M10.73 5.08A10.43 10.43 0 0 1 12 5c7 0 10 7 10 7a13.16 13.16 0 0 1-1.67 2.68"></path><path d="M6.61 6.61A13.526 13.526 0 0 0 2 12s3 7 10 7a9.74 9.74 0 0 0 5.39-1.61"></path><line x1="2" y1="2" x2="22" y2="22"></line></svg>,
  Spinner: () => <svg className="animate-spin" width="16" height="16" fill="none" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="3" className="opacity-25"></circle><path fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" className="opacity-75"></path></svg>,
  CheckCircle: () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path><polyline points="22 4 12 14.01 9 11.01"></polyline></svg>,
  Alert: () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></line></svg>,
  Sun: () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="5"></circle><line x1="12" y1="1" x2="12" y2="3"></line><line x1="12" y1="21" x2="12" y2="23"></line><line x1="4.22" y1="4.22" x2="5.64" y2="5.64"></line><line x1="18.36" y1="18.36" x2="19.78" y2="19.78"></line><line x1="1" y1="12" x2="3" y2="12"></line><line x1="21" y1="12" x2="23" y2="12"></line><line x1="4.22" y1="19.78" x2="5.64" y2="18.36"></line><line x1="18.36" y1="5.64" x2="19.78" y2="4.22"></line></svg>,
  Moon: () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"></path></svg>,
};

function LoginScreen() {
  const [usuario, setUsuario] = useState('');
  const [senha, setSenha] = useState('');
  const [lembrarMe, setLembrarMe] = useState(false);
  
  const [loading, setLoading] = useState(false);
  const [sucesso, setSucesso] = useState(false);
  const [erro, setErro] = useState('');
  
  const [showPassword, setShowPassword] = useState(false);
  const [mounted, setMounted] = useState(false);
  const [darkMode, setDarkMode] = useState(false);

  const userId = useId();
  const passwordId = useId();
  const rememberId = useId();

  useEffect(() => { 
    setMounted(true);
    const savedTheme = localStorage.getItem('vizumTheme');
    if (savedTheme) setDarkMode(savedTheme === 'dark');
  }, []);

  useEffect(() => {
    document.body.setAttribute('data-theme', darkMode ? 'dark' : 'light');
    localStorage.setItem('vizumTheme', darkMode ? 'dark' : 'light');
  }, [darkMode]);

  // ========================================================
  // LOGIN TRADICIONAL
  // ========================================================
  async function handleLogin(e) {
    e.preventDefault();
    setErro(''); setLoading(true); setSucesso(false);

    try {
      const response = await api.post('/login', { usuario, senha });
      
      localStorage.setItem('vizumToken', response.data.token);
      localStorage.setItem('vizumUser', JSON.stringify(response.data.user));
      if (lembrarMe) localStorage.setItem('vizumRememberUser', usuario);

      setLoading(false); 
      setSucesso(true);

      setTimeout(() => { window.location.href = '/home'; }, 800); 

    } catch (err) {
      setLoading(false);
      setErro(err.response?.data?.error || 'Usuário ou senha incorretos.');
    }
  }

  // ========================================================
  // LOGIN COM GOOGLE (Usando a lib oficial do React)
  // ========================================================
  const loginWithGoogle = useGoogleLogin({
    onSuccess: async (tokenResponse) => {
      setErro(''); setLoading(true); setSucesso(false);
      try {
        // Envia o access_token do Google para o seu Backend validar
        const response = await api.post('/login/google', {
          access_token: tokenResponse.access_token,
        });

        localStorage.setItem('vizumToken', response.data.token);
        localStorage.setItem('vizumUser', JSON.stringify(response.data.user));

        setLoading(false);
        setSucesso(true);

        setTimeout(() => { window.location.href = '/home'; }, 800); 
      } catch (err) {
        setLoading(false);
        setErro(err.response?.data?.error || 'Acesso negado. Usuário do Google não autorizado.');
      }
    },
    onError: () => {
      setErro('O login com o Google foi cancelado ou falhou.');
    }
  });

  const toggleTheme = () => setDarkMode(!darkMode);

  return (
    <div className={`layout-container ${sucesso ? 'is-success' : ''}`}>
      <GlobalStyles darkMode={darkMode} />

      {/* ================= LADO ESQUERDO (Formulário) ================= */}
      <div className="left-panel">
        <div className={`login-content ${mounted ? 'stagger-in' : ''}`}>
          
          <div className="header-row stagger-item">
            <div className="brand-header">
              <div className="logo-box"><Icons.Logo /></div>
              <span className="brand-name">Lumix Óticas</span>
            </div>
            
            <button type="button" className="theme-toggle-btn hide-on-success" onClick={toggleTheme}>
              <div className={`theme-icon ${darkMode ? 'active' : ''}`}>{darkMode ? <Icons.Sun /> : <Icons.Moon />}</div>
            </button>
          </div>

          <div className="text-header stagger-item">
            <h1 className={sucesso ? 'success-title' : ''}>
              {sucesso ? 'Acesso Liberado' : 'Fazer login'}
            </h1>
            <p className="hide-on-success">Acesse o painel de operações da ótica.</p>
          </div>

          {erro && (
            <div className="error-banner animate-shake hide-on-success stagger-item">
              <Icons.Alert /><span>{erro}</span>
            </div>
          )}

          <form onSubmit={handleLogin} className={`login-form ${loading ? 'form-processing' : ''}`}>
            
            <div className="hide-on-success-wrapper">
              <div className="form-group stagger-item">
                <label htmlFor={userId}>Usuário</label>
                <div className="input-wrap">
                  <span className="input-icon"><Icons.User /></span>
                  <input 
                    id={userId} type="text" placeholder="ex: admin" value={usuario}
                    onChange={e => setUsuario(e.target.value)} required disabled={loading || sucesso}
                  />
                </div>
              </div>

              <div className="form-group stagger-item">
                <label htmlFor={passwordId}>Senha</label>
                <div className="input-wrap">
                  <span className="input-icon"><Icons.Lock /></span>
                  <input 
                    id={passwordId} type={showPassword ? "text" : "password"} placeholder="••••••••" value={senha}
                    onChange={e => setSenha(e.target.value)} required disabled={loading || sucesso}
                  />
                  <button type="button" className="eye-btn" onClick={() => setShowPassword(!showPassword)} disabled={loading || sucesso}>
                    {showPassword ? <Icons.EyeOff /> : <Icons.Eye />}
                  </button>
                </div>
              </div>

              <div className="form-actions-row stagger-item">
                <label className="checkbox-wrap" htmlFor={rememberId}>
                  <input id={rememberId} type="checkbox" checked={lembrarMe} onChange={(e) => setLembrarMe(e.target.checked)} disabled={loading || sucesso}/>
                  <div className="checkmark"></div> <span>Lembrar de mim</span>
                </label>
                <a href="/recuperar-senha" className="forgot-link">Esqueceu a senha?</a>
              </div>
            </div>

            <button type="submit" className={`btn-primary stagger-item ${loading ? 'btn-loading' : ''} ${sucesso ? 'btn-success' : ''}`} disabled={loading || sucesso}>
              {sucesso ? (
                <><Icons.CheckCircle /> Autenticado</>
              ) : loading ? (
                <><Icons.Spinner /> Conectando...</>
              ) : (
                'Entrar'
              )}
            </button>

            {/* SEPARADOR E BOTÃO GOOGLE NATIVO */}
            <div className="hide-on-success-wrapper">
              <div className="divider stagger-item">
                <span>ou</span>
              </div>

              <button 
                type="button" 
                className="btn-google stagger-item" 
                disabled={loading || sucesso}
                onClick={() => loginWithGoogle()}
              >
                <Icons.Google /> Continuar com o Google
              </button>
            </div>
          </form>

        </div>
      </div>

      {/* ================= LADO DIREITO (Google Cloud Style) ================= */}
      <div className="right-panel">
        <div className="grid-overlay"></div>
        
        <div className={`hero-content ${mounted ? 'stagger-in' : ''}`}>
          <div className="hero-text stagger-item desktop-only">
            <h2>O ecossistema inteligente da sua ótica.</h2>
            <p>Gerencie ordens de serviço, rastreie entregas em tempo real e automatize seu pós-venda pelo WhatsApp.</p>
          </div>

          <div className="floating-elements-container stagger-item desktop-only">
            <div className="floating-card card-1">
              <div className="fc-header">
                <div className="fc-icon-wrap bg-blue"><Icons.Glasses /></div>
                <div className="fc-text">
                  <span>OS #1042 Concluída</span>
                  <small>Lentes prontas na montagem</small>
                </div>
              </div>
            </div>

            <div className="floating-card card-2">
              <div className="fc-header">
                <div className="fc-icon-wrap bg-green"><Icons.WhatsApp /></div>
                <div className="fc-text">
                  <span>Pós-venda Ativo</span>
                  <small>Mensagem enviada com sucesso</small>
                </div>
              </div>
            </div>

            <div className="floating-card card-3">
              <div className="fc-header">
                <div className="fc-icon-wrap bg-yellow"><Icons.MapPin /></div>
                <div className="fc-text">
                  <span>Pedido em Laboratório</span>
                  <small>Atualização de status automática</small>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="footer-legal desktop-only">
          © {new Date().getFullYear()} Lumix OS. Gestão Suprema.
        </div>
      </div>
    </div>
  );
}

// ==================================================================================
// WRAPPER DO GOOGLE OAUTH
// Este bloco exporta o LoginScreen envolvido no provedor de autenticação do Google
// Substitua o 'CLIENT_ID' pelo ID real criado no Google Cloud Console.
// ==================================================================================
export default function Login() {
  // Puxando a chave do arquivo .env no Create React App
  const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID;

  return (
    <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
      <LoginScreen />
    </GoogleOAuthProvider>
  );
}

// ==================================================================================
// ESTILOS CSS-IN-JS
// ==================================================================================
const GlobalStyles = ({ darkMode }) => {
  const theme = darkMode ? {
    bgLeft: '#202124', bgRight: '#171717', surface: '#303134',
    textMain: '#E8EAED', textSec: '#9AA0A6', textMuted: '#5F6368',
    border: '#3C4043', borderFocus: '#8AB4F8', 
    primary: '#8AB4F8', primaryHover: '#AECBFA', primaryText: '#202124',
    error: '#F28B82', errorBg: 'rgba(242, 139, 130, 0.1)', 
    success: '#81C995', inputBg: '#202124', gridLine: '#3C4043',
    btnGoogleBg: '#303134', btnGoogleBorder: '#5F6368', btnGoogleHover: '#3C4043',
    iconBlue: 'rgba(138, 180, 248, 0.15)', iconBlueText: '#8AB4F8',
    iconGreen: 'rgba(129, 201, 149, 0.15)', iconGreenText: '#81C995',
    iconYellow: 'rgba(253, 214, 99, 0.15)', iconYellowText: '#FDD663',
  } : {
    bgLeft: '#FFFFFF', bgRight: '#F8FAFD', surface: '#FFFFFF',
    textMain: '#202124', textSec: '#5F6368', textMuted: '#9AA0A6',
    border: '#DADCE0', borderFocus: '#1A73E8', 
    primary: '#1A73E8', primaryHover: '#174EA6', primaryText: '#FFFFFF',
    error: '#D93025', errorBg: '#FCE8E6', 
    success: '#1E8E3E', inputBg: '#FFFFFF', gridLine: '#E8EAED',
    btnGoogleBg: '#FFFFFF', btnGoogleBorder: '#DADCE0', btnGoogleHover: '#F8FAFD',
    iconBlue: '#E8F0FE', iconBlueText: '#1A73E8',
    iconGreen: '#E6F4EA', iconGreenText: '#1E8E3E',
    iconYellow: '#FEF7E0', iconYellowText: '#E37400',
  };

  return (
    <style>{`
    @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap');

    * { box-sizing: border-box; margin: 0; padding: 0; outline: none; }
    
    body, html { 
      height: 100dvh; font-family: 'Inter', -apple-system, sans-serif; 
      -webkit-font-smoothing: antialiased; background: ${theme.bgLeft}; color: ${theme.textMain};
      overflow: hidden; font-size: 13px;
    }

    .layout-container { display: flex; height: 100dvh; width: 100vw; }
    
    .left-panel { 
      flex: 0 0 440px; display: flex; flex-direction: column; justify-content: center; align-items: center; 
      padding: 40px; position: relative; background: ${theme.bgLeft}; z-index: 10; 
      transition: background-color 0.3s;
    }
    
    .right-panel { 
      flex: 1; position: relative; background: ${theme.bgRight}; display: flex; flex-direction: column; 
      justify-content: center; padding: 60px 80px; overflow: hidden; border-left: 1px solid ${theme.border}; 
      transition: background-color 0.3s; z-index: 1;
    }

    .login-content { width: 100%; max-width: 320px; position: relative; z-index: 10; }
    
    .header-row { display: flex; justify-content: space-between; align-items: center; width: 100%; margin-bottom: 32px; }
    .brand-header { display: flex; align-items: center; gap: 8px; }
    .logo-box { color: ${theme.primary}; display: grid; place-items: center; }
    .brand-name { font-size: 18px; font-weight: 600; color: ${theme.textMain}; letter-spacing: -0.5px; }

    .theme-toggle-btn { background: transparent; border: 1px solid ${theme.border}; border-radius: 50%; width: 36px; height: 36px; display: grid; place-items: center; cursor: pointer; color: ${theme.textSec}; transition: 0.2s; }
    .theme-toggle-btn:hover { background: ${theme.surface}; border-color: ${theme.textSec}; color: ${theme.textMain}; }

    .text-header { margin-bottom: 32px; }
    .text-header h1 { font-size: 24px; font-weight: 500; margin-bottom: 8px; color: ${theme.textMain}; letter-spacing: -0.5px; transition: color 0.3s ease; }
    .text-header p { color: ${theme.textSec}; font-size: 13px; font-weight: 400; line-height: 1.5;}
    .success-title { color: ${theme.success} !important; }

    .error-banner { display: flex; align-items: center; gap: 8px; background: ${theme.errorBg}; color: ${theme.error}; padding: 10px 14px; border-radius: 8px; font-size: 12px; font-weight: 500; margin-bottom: 20px; }
    .animate-shake { animation: shake 0.4s cubic-bezier(.36,.07,.19,.97) both; }
    @keyframes shake { 10%, 90% { transform: translate3d(-1px, 0, 0); } 20%, 80% { transform: translate3d(2px, 0, 0); } 30%, 50%, 70% { transform: translate3d(-3px, 0, 0); } 40%, 60% { transform: translate3d(3px, 0, 0); } }

    .form-group { margin-bottom: 16px; }
    .form-group label { display: block; font-size: 12px; font-weight: 500; color: ${theme.textMain}; margin-bottom: 6px; }
    .input-wrap { position: relative; display: flex; align-items: center; background: ${theme.inputBg}; border: 1px solid ${theme.border}; border-radius: 8px; height: 44px; transition: all 0.2s ease; }
    .input-wrap:focus-within { border-color: ${theme.borderFocus}; box-shadow: 0 0 0 2px ${darkMode ? 'rgba(138, 180, 248, 0.2)' : 'rgba(26, 115, 232, 0.2)'}; }
    .input-icon { padding: 0 12px; color: ${theme.textMuted}; display: flex; }
    .input-wrap:focus-within .input-icon { color: ${theme.borderFocus}; }
    .input-wrap input { flex: 1; height: 100%; border: none; background: transparent; font-size: 13.5px; color: ${theme.textMain}; font-weight: 400; width: 100%; padding-right: 12px;}
    .input-wrap input::placeholder { color: ${theme.textMuted}; }
    .eye-btn { background: none; border: none; padding: 0 12px; cursor: pointer; color: ${theme.textMuted}; height: 100%; display: flex; align-items: center; }
    .eye-btn:hover { color: ${theme.textMain}; }

    .form-actions-row { display: flex; justify-content: space-between; align-items: center; margin-bottom: 24px; margin-top: 8px; }
    
    .checkbox-wrap { display: flex; align-items: center; gap: 8px; font-size: 12px; font-weight: 500; color: ${theme.textSec}; cursor: pointer; }
    .checkbox-wrap input { display: none; }
    .checkmark { width: 16px; height: 16px; border: 1.5px solid ${theme.textMuted}; border-radius: 3px; display: grid; place-items: center; transition: 0.2s; position: relative;}
    .checkbox-wrap input:checked ~ .checkmark { background: ${theme.primary}; border-color: ${theme.primary}; }
    .checkbox-wrap input:checked ~ .checkmark::after { content: ''; width: 4px; height: 8px; border: solid ${darkMode ? '#202124' : '#FFFFFF'}; border-width: 0 1.5px 1.5px 0; transform: rotate(45deg); margin-bottom: 2px; }
    
    .forgot-link { font-size: 12px; font-weight: 500; color: ${theme.primary}; text-decoration: none; transition: 0.2s; }
    .forgot-link:hover { text-decoration: underline; }

    .btn-primary {
      width: 100%; height: 44px; background: ${theme.primary}; color: ${theme.primaryText};
      border: none; border-radius: 22px; font-size: 13.5px; font-weight: 500; cursor: pointer; 
      display: flex; align-items: center; justify-content: center; gap: 8px;
      transition: background 0.2s, box-shadow 0.2s;
    }
    .btn-primary:hover:not(:disabled) { background: ${theme.primaryHover}; box-shadow: 0 1px 3px rgba(0,0,0,0.15); }
    .btn-loading { cursor: wait; background: ${theme.border}; color: ${theme.textSec}; pointer-events: none;}
    .btn-success { background: ${theme.success} !important; color: ${darkMode ? '#202124' : '#FFFFFF'} !important; pointer-events: none;}
    
    .divider { display: flex; align-items: center; text-align: center; margin: 20px 0; }
    .divider::before, .divider::after { content: ''; flex: 1; border-bottom: 1px solid ${theme.border}; }
    .divider span { padding: 0 12px; color: ${theme.textSec}; font-size: 12px; font-weight: 500; }

    .btn-google {
      width: 100%; height: 44px; background: ${theme.btnGoogleBg}; color: ${theme.textMain};
      border: 1px solid ${theme.btnGoogleBorder}; border-radius: 22px; font-size: 13.5px; font-weight: 500; 
      cursor: pointer; display: flex; align-items: center; justify-content: center; gap: 10px;
      transition: background 0.2s, border-color 0.2s;
    }
    .btn-google:hover:not(:disabled) { background: ${theme.btnGoogleHover}; border-color: ${theme.textMuted}; }
    .btn-google:disabled { opacity: 0.6; cursor: not-allowed; }

    .stagger-in .stagger-item { opacity: 0; transform: translateY(10px); animation: staggerAnim 0.4s cubic-bezier(0.16, 1, 0.3, 1) forwards; }
    .stagger-in .stagger-item:nth-child(1) { animation-delay: 0.05s; }
    .stagger-in .stagger-item:nth-child(2) { animation-delay: 0.1s; }
    .stagger-in .stagger-item:nth-child(3) { animation-delay: 0.15s; }
    .stagger-in .stagger-item:nth-child(4) { animation-delay: 0.2s; }
    .stagger-in .stagger-item:nth-child(5) { animation-delay: 0.25s; }
    .stagger-in .stagger-item:nth-child(6) { animation-delay: 0.3s; }
    .stagger-in .stagger-item:nth-child(7) { animation-delay: 0.35s; }
    @keyframes staggerAnim { to { opacity: 1; transform: translateY(0); } }

    .hide-on-success { transition: opacity 0.3s ease; }
    .hide-on-success-wrapper { max-height: 500px; opacity: 1; overflow: hidden; transition: max-height 0.4s ease, opacity 0.3s ease; }
    .is-success .hide-on-success, .is-success .hide-on-success-wrapper { opacity: 0; max-height: 0; margin-bottom: 0; pointer-events: none; }

    .grid-overlay {
      position: absolute; inset: 0; background-image: linear-gradient(to right, ${theme.gridLine} 1px, transparent 1px), linear-gradient(to bottom, ${theme.gridLine} 1px, transparent 1px);
      background-size: 40px 40px; opacity: 0.7; mask-image: radial-gradient(circle at right, black, transparent 80%); -webkit-mask-image: radial-gradient(circle at right, black, transparent 80%);
    }

    .hero-content { position: relative; z-index: 10; max-width: 600px; }
    
    .hero-text h2 { font-size: 32px; line-height: 1.2; font-weight: 400; color: ${theme.textMain}; margin-bottom: 12px; letter-spacing: -0.5px;}
    .hero-text p { font-size: 15px; line-height: 1.5; color: ${theme.textSec}; font-weight: 400; max-width: 450px; }

    .floating-elements-container { position: relative; height: 300px; margin-top: 40px; }
    
    .floating-card { 
      position: absolute; padding: 16px; border-radius: 12px; transition: transform 0.3s ease; 
      background: ${theme.surface}; border: 1px solid ${theme.border};
      box-shadow: 0 4px 12px rgba(0,0,0,0.05);
    }
    
    .card-1 { top: 20px; left: 0px; width: 260px; animation: float1 6s ease-in-out infinite; z-index: 3; }
    .card-2 { top: 90px; left: 160px; width: 280px; animation: float2 7s ease-in-out infinite reverse; z-index: 2; }
    .card-3 { top: 160px; left: 40px; width: 250px; animation: float3 8s ease-in-out infinite; z-index: 4; }
    
    .fc-header { display: flex; align-items: center; gap: 14px; }
    .fc-icon-wrap { width: 36px; height: 36px; border-radius: 8px; display: grid; place-items: center; }
    
    .bg-blue { background: ${theme.iconBlue}; color: ${theme.iconBlueText}; }
    .bg-green { background: ${theme.iconGreen}; color: ${theme.iconGreenText}; }
    .bg-yellow { background: ${theme.iconYellow}; color: ${theme.iconYellowText}; }
    
    .fc-text { display: flex; flex-direction: column; line-height: 1.3; }
    .fc-text span { font-size: 13px; font-weight: 600; color: ${theme.textMain}; }
    .fc-text small { font-size: 11.5px; font-weight: 400; color: ${theme.textSec}; margin-top: 2px;}

    @keyframes float1 { 0%, 100% { transform: translateY(0px); } 50% { transform: translateY(-4px); } }
    @keyframes float2 { 0%, 100% { transform: translateY(0px); } 50% { transform: translateY(-6px); } }
    @keyframes float3 { 0%, 100% { transform: translateY(0px); } 50% { transform: translateY(-3px); } }
    .animate-spin { animation: spin 1s linear infinite; }
    @keyframes spin { to { transform: rotate(360deg); } }

    .footer-legal { position: absolute; bottom: 24px; right: 40px; font-size: 11px; color: ${theme.textMuted}; font-weight: 500; }
    
    .desktop-only { display: block; }

    @media (max-width: 960px) {
      .desktop-only { display: none !important; }
      .layout-container { display: flex; align-items: center; justify-content: center; background: ${theme.bgRight}; }
      .right-panel { display: none; }
      .left-panel { flex: none; width: 100%; max-width: 400px; background: transparent; padding: 24px; }
      .login-content { background: ${theme.surface}; border: 1px solid ${theme.border}; border-radius: 16px; padding: 32px 24px; box-shadow: 0 4px 24px rgba(0,0,0,0.04); width: 100%; max-width: 100%; }
      .header-row { justify-content: center; margin-bottom: 24px; position: relative;}
      .brand-header { flex-direction: column; gap: 12px; }
      .logo-box { width: 48px; height: 48px; border-radius: 12px; }
      .logo-box svg { width: 28px; height: 28px; }
      .brand-name { font-size: 20px; font-weight: 500;}
      .theme-toggle-btn { position: absolute; top: -16px; right: 0; border: none; background: transparent;}
      .text-header { text-align: center; margin-bottom: 32px; }
      .text-header h1 { font-size: 22px; }
      .text-header p { font-size: 14px; }
    }

    @media (max-width: 480px) {
      .left-panel { padding: 16px; }
      .login-content { padding: 24px 20px; border-radius: 12px;}
    }
  `}</style>
  );
};